<template>
	<div class="slide-first-wrapper">

		<div class="side-menu-navigation">
			<span class="links-header">{{ $t('sideMenu.platform') }}</span>
			<span
				@click="closeSideMenuWithRedirectTo(routes.home)"
				class="link"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/platform.svg" alt="platform">
					<span>DRC </span>
				</span>
			</span>

			<span class="links-header">{{ $t('sideMenu.pages') }}</span>
			<span
				@click="closeSideMenuWithRedirectTo(routes.gopHome)"
				class="link"
				:class="checkIsActivePage(routes.gopHome)"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/home.svg" alt="plus">
					<span>{{ $t('sideMenu.home') }}</span>
				</span>
			</span>


			<span
				@click="closeSideMenuWithRedirectTo(routes.gopSearch)"
				class="link"
				:class="checkIsActivePage(routes.gopSearch)"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/search.svg" alt="plus">
					<span>{{ $t('sideMenu.search') }}</span>
				</span>
			</span>


			<span
				@click="closeSideMenuWithRedirectTo(routes.createOffer)"
				class="link"
				:class="checkIsActivePage(routes.createOffer)"
				v-if="innerWidth > 600 & innerHeight > 600 && hasPermission(PERMISSIONS.additionalGopAccess)"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/plus.svg" alt="plus">
					<span>{{ $t('sideMenu.createOffer') }}</span>
				</span>
			</span>

			<span
				@click="closeSideMenuWithRedirectTo(routes.createSector)"
				class="link"
				:class="checkIsActivePage(routes.createSector)"
				v-if="innerWidth > 600 & innerHeight > 600 && hasPermission(PERMISSIONS.additionalGopAccess)"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/plus.svg" alt="plus">
					<span>{{ $t('sideMenu.createSector') }}</span>
				</span>
			</span>

			<span
				@click="closeSideMenuWithRedirectTo(routes.recognitions)"
				class="link"
				:class="checkIsActivePage(routes.recognitions)"
				v-if="innerWidth > 600 & innerHeight > 600"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/gop/assets/icons/cup.svg" alt="plus">
					<span>{{ $t('sideMenu.recognitions') }}</span>
				</span>
			</span>

			<span
				@click="closeSideMenuWithRedirectTo(routes.createRecognition)"
				class="link"
				:class="checkIsActivePage(routes.createRecognition)"
				v-if="innerWidth > 600 & innerHeight > 600 && hasPermission(PERMISSIONS.additionalGopAccess)"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/plus.svg" alt="plus">
					<span>{{ $t('sideMenu.createRecognition') }}</span>
				</span>
			</span>

			<span
				@click="closeSideMenuWithRedirectTo(routes.savedContent)"
				class="link"
				:class="checkIsActivePage(routes.savedContent)"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/saved-filled.svg" alt="saved">
					<span>{{ $t('sideMenu.savedContent') }}</span>
				</span>
			</span>

		</div>

	</div>
</template>

<script>
import slideMenuMixin from "@/common/mixins/slide-menu-mixin";
import {EventSideMenu} from "@/common/configurations/event-bus";
import {PERMISSIONS} from "@/common/utils/constants.js";

export default {
	name: "GopSideMenu",
	mixins: [slideMenuMixin],
	data() {
		return {
			routes: {
				home: "/home",
				createOffer: '/gop/create-offer',
				gopHome: '/gop/home',
				gopSearch: '/gop/search',
				createSector: '/gop/create-sector-presentation',
				createRecognition: '/gop/create-recognition',
				recognitions: '/gop/recognitions',
				savedContent: '/gop/search?showOnlyFavourites=true'
			},
			innerWidth: window.innerWidth,
			innerHeight: window.innerHeight,
			PERMISSIONS: PERMISSIONS
		}
	},
	methods: {
		closeSideMenuWithRedirectTo(route) {
			if (window.innerWidth < 768) {
				EventSideMenu.$emit("toggle-sidemenu");
				EventSideMenu.$emit("toggle-burger-logo");
				this.$parent.$parent.$refs.mainContent.style.overflow = "auto";
			}
			this.redirectToPage(route);
		},
		redirectToPage(route) {
			if (this.$route.path === route) {
				this.$router.replace({'query': null}).catch(error => {
					if (error.name != "NavigationDuplicated") {
						throw error;
					}
				});
				location.reload();
			} else {
				this.$router.push(route)
			}
		},
	}
}
</script>

<style lang="sass" scoped>
@import "@/common/assets/css/_variables.scss"
.slide-first-wrapper
	.link
		&:hover
			.gop-container
				background-color: #d9fafa

		&.active
			.gop-container
				background-color: $gop-blue
</style>
